import React, { useCallback, useEffect, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { isMobile, MainWr, UnderMaintenanceContainer } from '@pascal/pascal-core';
import { popupStore } from '@pascal/pascal-core/shared/core/store';

import { Factory } from './core';
import { WebGame } from './containers/webGame';
import { MobileGame } from './containers/mobileGame';
import { gameLiveConnection } from './services';
import { RoutePaths } from './enums/routes';

function App() {
  const components = useMemo(
    () => [
      {
        path: RoutePaths.game,
        element: (
          <UnderMaintenanceContainer>
            {isMobile() ? <MobileGame /> : <WebGame />}
          </UnderMaintenanceContainer>
        ),
        defaultRedirectComponent: true,
      },
      {
        path: RoutePaths.replay,
        element: (
          <UnderMaintenanceContainer>
            {isMobile() ? <MobileGame /> : <WebGame />}
          </UnderMaintenanceContainer>
        ),
      },
    ],
    []
  );

  const lostInternetConnection = useCallback(() => {
    popupStore.onConnectionError(true);
    gameLiveConnection.stop();
  }, []);

  const reconnectInternet = useCallback(() => {
    // gameService.socketRecursiveReconnecting();
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection, reconnectInternet]);

  return (
    <BrowserRouter>
      <MainWr>
        <Factory components={components} />
      </MainWr>
    </BrowserRouter>
  );
}

export default App;
